import { render, staticRenderFns } from "./agreementDialog.vue?vue&type=template&id=1bbe2c7e&scoped=true"
import script from "./agreementDialog.vue?vue&type=script&lang=js"
export * from "./agreementDialog.vue?vue&type=script&lang=js"
import style0 from "./agreementDialog.vue?vue&type=style&index=0&id=1bbe2c7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe2c7e",
  null
  
)

export default component.exports